import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Page } from "@ui/page/Page";
import { EventsTable } from "../EventsTable";
import { Activity } from "lucide-react";

export const EventsPage = () => {
	useLocale();
	return (
		<Page label={msg("events")} description={msg("operationalActivityStatusChangesAndSystemTimeline")} icon={<Activity size={20} />}>
			<EventsTable />
		</Page>
	);
};
